import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { formatMoney } from '../utils/utils.js'
require(`../assets/${process.env.PAGE}/css/product-option.css`);

class ProductOption extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
    }
        this.selectProduct = this.selectProduct.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { currentAmount, handleSubmitSelectedProduct } = this.props;
        if(currentAmount !== nextProps.currentAmount){
            handleSubmitSelectedProduct()
            this.setState({isActive:false})
        }
    }

    selectProduct() {
        this.setState({isActive:true})
        this.props.onClick(this.props.quotaOption.toString(), this.props.amountQuotaOption);
    }

    render() {
        const { quotaOption, amountQuotaOption, isDiscount } = this.props;

        const { isActive } = this.state;

        const quotaOptionFormatted = quotaOption.toString()
        const amountQuotaOptionFormatted = formatMoney(amountQuotaOption, 0, ',', '.')

        const buttonClasses = `btn pd-choise-button ${isActive ? 'active' : ''}`;

        return (
            <div className="product-option">
                <Button
                    className={buttonClasses}
                    onClick={this.selectProduct}
                    disabled={ isDiscount ? true : false }>
                    <span className="quotas">{`${quotaOptionFormatted} cuotas de`}</span>
                    <span className="amount">{amountQuotaOptionFormatted}</span>
                </Button>
            </div>
        );
    }
}


export default ProductOption;


/** WEBPACK FOOTER **
 ** ./src/components/ProductOption.js
 **/